import PropTypes from 'prop-types'
import React from 'react'
import { Box, Grid, Icon, IconButton } from '@mui/material'

const ElementCard = ({
    children = undefined,
    color = 'white',
    className = '',
    icon = '',
    icon2 = '',
    iconColor = 'white',
    iconClassName = '',
    button = '',
    buttonColor = 'white',
    style = {},
    onClick = () => { },
    onClickButton = () => { },
}) => (
    <Box className={`${color} ${className || ''}`} sx={{ ...style, padding: '5px 10px', margin: '2px', borderRadius: '10px' }}>
        <Grid container spacing={2} alignItems='center' onClick={onClick}>
            {!!icon && (
                <Grid size='auto'>
                    <Icon className={iconClassName} sx={{ color: iconColor }}>{icon}</Icon>
                </Grid>
            )}
            <Grid size='grow' className={color !== 'white' ? 'white-text' : ''}>
                {children}
            </Grid>
            {!!icon2 && (
                <Grid size='auto'>
                    <Icon className={iconClassName} sx={{ color: iconColor }}>{icon2}</Icon>
                </Grid>
            )}
            {!!button && (
                <Grid size='auto'>
                    <IconButton
                        color='primary'
                        onClick={onClickButton}
                        sx={{ color: buttonColor, fontSize: '2rem' }}
                    >
                        <Icon fontSize='inherit'>{button}</Icon>
                    </IconButton>
                </Grid>
            )}
        </Grid>
    </Box>
)

ElementCard.propTypes = {
    children: PropTypes.element.isRequired,
    icon: PropTypes.string,
    iconColor: PropTypes.string,
    icon2: PropTypes.string,
    iconClassName: PropTypes.string,
    button: PropTypes.string,
    buttonColor: PropTypes.string,
    onClick: PropTypes.func,
    onClickButton: PropTypes.func,
    color: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
}

export default ElementCard
